/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tl_Agenda_UnscheduledInputs */

const en_tl_agenda_unscheduled = /** @type {(inputs: Tl_Agenda_UnscheduledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} items have no dates yet.`)
};

const de_tl_agenda_unscheduled = /** @type {(inputs: Tl_Agenda_UnscheduledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Vorgänge haben noch keine Termine.`)
};

/**
* | output |
* | --- |
* | "{count} items have no dates yet." |
*
* @param {Tl_Agenda_UnscheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_agenda_unscheduled = /** @type {((inputs: Tl_Agenda_UnscheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Agenda_UnscheduledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_agenda_unscheduled(inputs)
	return en_tl_agenda_unscheduled(inputs)
});